// extracted by mini-css-extract-plugin
export var imageWrapper = "QuoteAndImage-module--imageWrapper--6-qKH";
export var quote = "QuoteAndImage-module--quote--rfBUG";
export var quoteContent = "QuoteAndImage-module--quoteContent--e694I";
export var wrapper = "QuoteAndImage-module--wrapper--pIHGW";